import React, { useReducer } from "react";
import DmNavbarReducer from "./dmNavbarReducer";
import DmNavbarContext from "./dmNavbarContext";

const DmNavbarState = (props) => {
  const initialState = {
    customerCode: null,
    customerUser: null,
  };

  const [state, dispatch] = useReducer(DmNavbarReducer, initialState);

  return (
    <DmNavbarContext.Provider value={[state, dispatch]}>
      {props.children}
    </DmNavbarContext.Provider>
  );
};

export default DmNavbarState;
